import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTrash, FaPlus, FaTv } from 'react-icons/fa';
import "../styles/dashboardAdmin.css"; // 🔹 Usando o CSS do Dashboard para garantir a margem e o layout

const GerenciarTransmissoes = () => {
    const [transmissoes, setTransmissoes] = useState([]);
    const [form, setForm] = useState({ titulo: '', urlYoutube: '', ordem: 0 });

    useEffect(() => { carregar(); }, []);

    const carregar = async () => {
        try {
            const res = await axios.get('https://api.ticketdovaqueiro.com/api/transmissoes');
            setTransmissoes(res.data);
        } catch (error) {
            console.error("Erro ao carregar transmissões:", error);
        }
    };

    const salvar = async () => {
        if (!form.titulo || !form.urlYoutube) {
            alert("Preencha o título e o link do YouTube!");
            return;
        }

        try {
            await axios.post('https://api.ticketdovaqueiro.com/api/transmissoes/salvar', form);
            setForm({ titulo: '', urlYoutube: '', ordem: 0 });
            carregar();
        } catch (error) {
            alert("Erro ao salvar o link. Verifique se a URL do YouTube é válida.");
        }
    };

    const excluir = async (id) => {
        if(window.confirm("Tem certeza que deseja excluir esta transmissão?")) {
            await axios.delete(`https://api.ticketdovaqueiro.com/api/transmissoes/${id}`);
            carregar();
        }
    };

    return (
        <div className="dashboard-admin"> {/* 🔹 AQUI ESTÁ A CORREÇÃO: Usando a classe que tem margin-left: 270px */}
            <h1><FaTv style={{ marginRight: '15px', color: '#fdd212' }} /> Gerenciar TV Ao Vivo</h1>
            
            {/* Seção de Cadastro com o estilo dos Filtros do seu Dashboard */}
            <div className="filtros" style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#2a2a2a', borderRadius: '12px', display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '200px' }}>
                    <label style={{ color: '#fdd212', display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600' }}>Título da Vaquejada</label>
                    <input 
                        type="text" 
                        placeholder="Ex: Vaquejada Parque X..." 
                        value={form.titulo} 
                        onChange={e => setForm({...form, titulo: e.target.value})} 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #444', background: '#1a1a1a', color: '#fff' }}
                    />
                </div>
                
                <div style={{ flex: 2, minWidth: '250px' }}>
                    <label style={{ color: '#fdd212', display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600' }}>Link do YouTube</label>
                    <input 
                        type="text" 
                        placeholder="https://youtube.com/watch?v=..." 
                        value={form.urlYoutube} 
                        onChange={e => setForm({...form, urlYoutube: e.target.value})} 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #444', background: '#1a1a1a', color: '#fff' }}
                    />
                </div>

                <div style={{ width: '80px' }}>
                    <label style={{ color: '#fdd212', display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600' }}>Ordem</label>
                    <input 
                        type="number" 
                        value={form.ordem} 
                        onChange={e => setForm({...form, ordem: e.target.value})} 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #444', background: '#1a1a1a', color: '#fff', textAlign: 'center' }}
                    />
                </div>

                <button 
                    onClick={salvar} 
                    style={{
                        backgroundColor: '#fdd212',
                        color: '#000',
                        border: 'none',
                        padding: '12px 25px',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer',
                        height: '48px'
                    }}
                >
                    <FaPlus /> Adicionar
                </button>
            </div>

            {/* Tabela com o estilo que você já usa no sistema */}
            <div className="estatisticas-container" style={{ display: 'block' }}>
                <div className="card" style={{ padding: '0', overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', color: '#fff' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#333', textAlign: 'left' }}>
                                <th style={{ padding: '15px', width: '80px', textAlign: 'center' }}>Ordem</th>
                                <th style={{ padding: '15px' }}>Título da Transmissão</th>
                                <th style={{ padding: '15px' }}>ID do Vídeo</th>
                                <th style={{ padding: '15px', width: '100px', textAlign: 'center' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transmissoes.length === 0 ? (
                                <tr>
                                    <td colSpan="4" style={{ padding: '30px', textAlign: 'center', color: '#888' }}>Nenhuma transmissão cadastrada.</td>
                                </tr>
                            ) : (
                                transmissoes.map(t => (
                                    <tr key={t._id} style={{ borderBottom: '1px solid #333' }}>
                                        <td style={{ padding: '15px', textAlign: 'center', fontWeight: 'bold', color: '#fdd212' }}>{t.ordem}</td>
                                        <td style={{ padding: '15px', fontWeight: '500' }}>{t.titulo}</td>
                                        <td style={{ padding: '15px', color: '#888', fontSize: '13px' }}>{t.youtubeId}</td>
                                        <td style={{ padding: '15px', textAlign: 'center' }}>
                                            <button 
                                                onClick={() => excluir(t._id)}
                                                style={{ background: 'none', border: 'none', color: '#ff4444', cursor: 'pointer', fontSize: '18px' }}
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default GerenciarTransmissoes;